<template>
  <div class="container-fluid px-md-4">
    <div class="panel-heading my-2">
      <h2 class="text-left">External Provider Management</h2>
    </div>
    <form class="needs-validation px-2 pt-2">
      <div
        class="form-group row mx-0 justify-content-end"
        :style="{ marginBottom: '1rem' }"
      >
        <div class="my-2">
          <button
            title="Add new"
            class="k-button k-secondary"
            @click="insert"
            type="button"
          >
            <i class="fa fa-plus mr-2" aria-hidden="true"></i>

            Add new
          </button>
        </div>
      </div>
    </form>
    <div class="example-wrapper" v-if="providers">
      <Grid
        ref="grid"
        :style="{ height: '55vh' }"
        :pageable="true"
        :sortable="true"
        :resizable="true"
        :filterable="true"
        :filter="filter"
        :groupable="false"
        :group="group"
        :sort="sort"
        :skip="skip"
        :data-items="gridData"
        :columns="columns"
        :take="take"
        @datastatechange="dataStateChange"
        @expandchange="expandChange"
      >
        <template v-slot:myTemplate="{ props }">
          <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
        </template>
        <grid-toolbar class="text-left"> </grid-toolbar>
        <grid-norecords> There is no data available custom </grid-norecords>
      </Grid>
      <dialog-container
        v-if="externalProviderInEdit"
        :dialog-title="dialogTitle"
        :providerTypes="providerTypes"
        :data-item="externalProviderInEdit"
        @save="save"
        @cancel="cancel"
      >
      </dialog-container>
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import DialogContainer from "./DialogContainer";
import { process } from "@progress/kendo-data-query";
import CommandCell from "./CommandCell";
import axios from "axios";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { oidcSettings } from "../../services/store";

export default {
  components: {
    Grid: Grid,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
    "dialog-container": DialogContainer,
    custom: CommandCell,
    dropdownlist: DropDownList,
  },
  props: {
    identity: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      base_url: undefined,
      sort: [{ field: "id", dir: "asc" }],
      externalProviderInEdit: undefined,
      providers: undefined,
      providerTypes: undefined,
      tenants: [],
      selectedIdentity: this.identity,
      filter: {
        logic: "and",
        filters: [],
      },
      gridData: [],
      skip: 0,
      take: 10,
      group: [],
      columns: [
        {
          field: "displayName",
          title: "External Provider Name",
          width: "150px",
        },
        { field: "fields", title: "Fields", filterable: false },

        { field: "predefinedType", title: "Predefined Type" },

        { field: "type", title: "Type" },

        { field: "imgUrl", title: "Img Url" },
      ],
    };
  },
  computed: {
    dialogTitle() {
      return `${
        this.externalProviderInEdit.type === undefined ? "Add" : "Edit"
      } External Provider`;
    },
  },
  mounted: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    this.getProviders();
    this.getProviderTypes();
  },
  watch: {
    identity: function () {
      this.selectedIdentity = this.identity;
    },
  },
  methods: {
    dataStateChange: function (event) {
      this.createAppState(event.data);
      console.log(event);
    },

    expandChange: function (event) {
      Vue.set(event.dataItem, event.target.$props.expandField, event.value);
    },
    createAppState: function (dataState) {
      this.group = dataState.group;
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.filter = dataState.filter;
      this.sort = dataState.sort;
      console.log(dataState);
      this.getData();
    },
    getData: function () {
      console.log("aaa", this.filter);
      this.gridData = process(this.providers, {
        take: this.take,
        skip: this.skip,
        group: this.group,
        sort: this.sort,
        filter: this.filter,
      });
    },
    async getProviders() {
      try {
        const response = await axios.get(
          this.base_url + "ExternalProvider/GetAllExternalProviders"
        );
        this.providers = response.data.result;
        this.getData();

        console.log(response.data.message);
      } catch (err) {
        console.log(err);
      }
    },
    async getProviderTypes() {
      try {
        const response = await axios.get(
          this.base_url + "ExternalProvider/GetProviderTypes"
        );
        this.providerTypes = response.data.result;
        console.log(response.data.message);
      } catch (err) {
        console.log(err);
      }
    },
    edit(dataItem) {
      this.externalProviderInEdit = this.cloneProduct(dataItem);
    },
    async remove(dataItem) {
      try {
        //const response = await axios.post("https://localhost:5001/api/User/AddUser", data);

        const response = await axios.delete(
          this.base_url +
            "ExternalProvider/DeleteExternalAuthProvider/" +
            dataItem.externalProviderID +
            "/" +
            this.selectedIdentity.id
        );
        //this.$router.push("/home");
        this.providers = this.providers.filter(
          (p) => p.externalProviderID !== dataItem.externalProviderID
        );
        this.getData();
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    async save() {
      const dataItem = this.externalProviderInEdit;
      let data = {
        Name: dataItem.name,
        DisplayName: dataItem.displayName,
        PredefinedType: dataItem.predefinedType,
      };
      try {
        const formData = new FormData();
        formData.append("file", dataItem.logo);
        const response = await axios
          .post(
            this.base_url +
              "ExternalProvider/AddExternalProvider/" +
              dataItem.name +
              "/" +
              dataItem.displayName +
              "/" +
              dataItem.predefinedType,
            formData,
            {
              header: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((res) => {
            var newObject = res.data.result;
            this.providers.push(newObject);
          });
        this.getData();

        //this.$router.push("/home");
      } catch (err) {
        console.log("Ooops!" + err);
      }
      this.externalProviderInEdit = undefined;
    },
    cancel() {
      this.externalProviderInEdit = undefined;
    },
    insert() {
      this.externalProviderInEdit = {};
    },
    cloneProduct(product) {
      return Object.assign({}, product);
    },
  },
};
</script>
<style >
.error {
  color: brown;
  margin: auto;
  text-align: left;
  padding: 5px;
}

.needs-validation {
  background: white;
}
</style>